// Temporary: the Typography variant showcase. Delete this folder to remove it.
import TypographyShowcasePage from "./TypographyShowcasePage"

export default {
  "/typography-showcase": TypographyShowcasePage,
}
